import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalOnlineMenuDocument = gql`
  query SalesPortalOnlineMenu($restaurantUUID: uuid!, $supplierUUID: uuid!) {
    getBusinessDetails(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      menu_items {
        ingredients
        item_name
      }
    }
  }
`;
export function useSalesPortalOnlineMenuQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalOnlineMenuQuery,
    Types.SalesPortalOnlineMenuQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalOnlineMenuQuery,
    Types.SalesPortalOnlineMenuQueryVariables
  >(SalesPortalOnlineMenuDocument, options);
}
export function useSalesPortalOnlineMenuLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalOnlineMenuQuery,
    Types.SalesPortalOnlineMenuQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalOnlineMenuQuery,
    Types.SalesPortalOnlineMenuQueryVariables
  >(SalesPortalOnlineMenuDocument, options);
}
export type SalesPortalOnlineMenuQueryHookResult = ReturnType<
  typeof useSalesPortalOnlineMenuQuery
>;
export type SalesPortalOnlineMenuLazyQueryHookResult = ReturnType<
  typeof useSalesPortalOnlineMenuLazyQuery
>;
export type SalesPortalOnlineMenuQueryResult = Apollo.QueryResult<
  Types.SalesPortalOnlineMenuQuery,
  Types.SalesPortalOnlineMenuQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalOnlineMenuQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalOnlineMenuQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalOnlineMenuQuery,
    Types.SalesPortalOnlineMenuQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalOnlineMenuQuery,
    Types.SalesPortalOnlineMenuQueryVariables
  >(SalesPortalOnlineMenuDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalOnlineMenuLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalOnlineMenuLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalOnlineMenuQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalOnlineMenuQuery,
    Types.SalesPortalOnlineMenuQueryVariables
  >(SalesPortalOnlineMenuDocument, lazyOptions);
}
